import Vue from 'vue'

export default async (data) => {
  // data = { amount: number, payment_method: String }
  let res = await Vue.axios.post(`/billing/gen_payment_req_url`, data)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/gen-payment.js